module.exports = __webpack_public_path__ + "img/logo.050a04a3.svg";